import { render, staticRenderFns } from "./TeamSelector.vue?vue&type=template&id=05c490bc"
import script from "./TeamSelector.vue?vue&type=script&lang=js"
export * from "./TeamSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports